const getBaseUrl = () => process.env.REACT_APP_BACKEND_URL || '';

const getUserId = () => localStorage.getItem('user_id') || null;

const apiFetch = async (path, options = {}) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${getBaseUrl()}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const body = await response.json();
      message = body.error || body.message || message;
    } catch {
      // ignore parse errors
    }
    throw new Error(message);
  }
  if (response.status === 204) return null;
  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

const mapPropertiesToBusinessUnits = (properties) =>
  (Array.isArray(properties) ? properties : [])
    .filter((p) => p.businessUnitId)
    .map((p) => ({
      businessUnitId: p.businessUnitId,
      businessUnitName: p.propertyName,
      businessUnitCode: p.propertyCode,
      propertyId: p.propertyId,
      jobCodeLevel2: p.jobCodeLevel2 ?? p.job_code_level_2 ?? '',
      parentBusinessUnitId: null,
      status: p.status || 'ACTIVE',
    }));

export const fetchPropertyBusinessUnits = async (tenantId, { scope = 'user' } = {}) => {
  if (!tenantId) return [];

  const properties = await apiFetch(`conductor/cash-recon/properties/by-tenant?tenant_id=${tenantId}`);
  const list = Array.isArray(properties) ? properties : [];

  if (scope === 'tenant') {
    return mapPropertiesToBusinessUnits(list);
  }

  const userId = getUserId();
  if (!userId) {
    return mapPropertiesToBusinessUnits(list);
  }

  const userProps = await apiFetch(
    `conductor/user-tenant-properties?tenant_id=${tenantId}&user_id=${userId}`
  );
  const allowedPropertyIds = new Set(
    (Array.isArray(userProps) ? userProps : []).map((p) => p.propertyId)
  );

  return mapPropertiesToBusinessUnits(
    list.filter((p) => p.propertyId && allowedPropertyIds.has(p.propertyId))
  );
};
